import produce from 'immer';
import { CURRENCY, PERIODS } from '../constants/constants';
import { default as _u } from 'underscore';
import { CART_ACCOUNT } from '../constants/cartContstants';
import applyAccountPeriods from '../../mutators/applyAccountPeriods';

const initialState = {
    periods: {},
    currencies: {},
    account: null
};

export default produce((draft = initialState, action) => {
    const { type, data } = action;

    switch (type) {
        case CART_ACCOUNT:
            draft.account = data?.account;
            if (draft?.periods) {
                _u.each(draft?.periods, (periods, productId) => {
                    applyAccountPeriods(periods, {
                        data: { productId: productId, account: draft?.account, merge: action?.data?.merge }
                    });
                });
            }
            break;
        case PERIODS:
            const periods = data.tariffs.reduce((acc, tariff) => {
                if (tariff.periods) {
                    Object.values(tariff.periods).forEach((period) => {
                        if (!acc[tariff?.product_id]) {
                            acc[tariff?.product_id] = {};
                        }

                        acc[tariff?.product_id][
                            `${period.interval_count} ${tariff.billing_period}`
                        ] = {
                            name: `${period.interval_count} ${tariff.billing_period}`,
                            discount: period.interval_discount,
                            unit: period.interval_discount_unit,
                            billing_period: tariff.billing_period,
                            interval: period.interval_count,
                            product_id: tariff?.product_id,
                            interval_bonus: period?.interval_bonus,
                            interval_bonus_unit: period?.interval_bonus_unit,
                            license_valid_till: period?.license_valid_till
                        };
                    });
                } else {
                    acc[`${tariff.billing_period}`] = {
                        name: `${tariff.billing_period}`,
                    };
                }

                return acc;
            }, {});
            draft.periods = periods;
            const productIds = _u(data?.tariffs).map(tariff => tariff?.product_id).filter(item => !!item);
            _u.each(_u.uniq(productIds), (productId) => {
                applyAccountPeriods(draft.periods[productId], {
                    data: { productId: productId, account: draft?.account }
                });
            });
            break;
        case CURRENCY:
            draft.currencies = data;
            break;
        default:
            return draft;
    }
});
